var render = function render(_c,_vm){return _c('div',{staticClass:"article-info__lead",class:_vm.props.fontSizeClass},_vm._l((_vm.props.lead.content),function(fragment,index){return _c('ContentFragment',{key:index,attrs:{"content":fragment}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }